module.exports = __webpack_public_path__ + "img/3.2f6d2d7c.jpg";